import React from 'react'
import useInputs from '../../../utils/hooks/useInputs'
import LabeledNumber from '../../common/form-components/labeled-inputs/LabeledNumber'
import LabeledText from '../../common/form-components/labeled-inputs/LabeledText'
import SaveButton from '../../common/buttons/SaveButton'
import { validators } from '../../../utils/helpers/validators'
import LabeledInputMask from '../../common/form-components/labeled-inputs/LabeledInputMask'
import LabeledTextarea from '../../common/form-components/labeled-inputs/LabeledTextarea'
import './suppliersForm.scss'
import { propsInputNumberCurrency } from '../../../utils/constants/common'

const SuppliersForm = ({ handleSubmit }) => {
  const { inputs, onChangeInputs } = useInputs({})

  const validateForm =
    validators.hasValue(inputs?.code) && validators.hasValue(inputs?.name)

  return (
    <div className="suppliers-form">
      <div className="modal-content-wrapper">
        <div className="content-wrapper">
          <LabeledNumber
            idLabel="code"
            required
            name="code"
            value={inputs?.code}
            onChange={onChangeInputs}
          />
          <LabeledText
            idLabel="name"
            required
            name="name"
            value={inputs?.name}
            onChange={onChangeInputs}
          />
          <LabeledText
            idLabel="contact"
            name="contact"
            value={inputs?.contact}
            onChange={onChangeInputs}
          />
        </div>

        <div className="content-wrapper">
          <LabeledInputMask
            idLabel="phone"
            name="phone"
            mask="999 999 999"
            value={inputs?.phone}
            onChange={onChangeInputs}
          />

          <LabeledText
            idLabel="email"
            name="email"
            value={inputs?.email}
            onChange={onChangeInputs}
          />

          <LabeledNumber
            idLabel="prices"
            name="prices"
            value={inputs?.prices}
            onChange={onChangeInputs}
            {...propsInputNumberCurrency}
          />
          <LabeledText
            idLabel="pay"
            name="pay"
            value={inputs?.pay}
            onChange={onChangeInputs}
          />
        </div>
        <LabeledTextarea
          idLabel="others"
          name="others"
          value={inputs?.others}
          onChange={onChangeInputs}
          rows={2}
        />
      </div>
      <div className="modal-btn-container">
        <SaveButton
          btnClass="btn-save-modal"
          onClick={() => handleSubmit(inputs)}
          isDisabled={!validateForm}
        />
      </div>
    </div>
  )
}

export default SuppliersForm
